import { AddressResponseModel, CommonResponseModel, CreateDlMasterReqDto, CreatePaRequestListDto, PaginationDto, ProductionPlanModel } from "@project-management-system/shared-models";
import { CommonAxiosService } from "../common-axios-service-prs";



export class DlModuleService extends CommonAxiosService {
    private URL = "/dl-automation";

    async getDlMastersData(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/getDlMastersData")
    }

    async saveDlMasterData(req: CreateDlMasterReqDto[], config?: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/saveDlMasterData", req, config)
    }

    async saveDlProductionPlan(req: ProductionPlanModel[], config?: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/saveDlProductionPlan", req, config)
    }

    async savPaRequestList(req: CreatePaRequestListDto[], config?: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/savPaRequestList", req, config)
    }

    async getProductionPlan(config?: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/getProductionPlan", undefined, config)
    }
    async getPARequestList(req: PaginationDto, config?: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + "/getPARequestList", req, config)
    }
}